import React from 'react';

const DeactivateMerchantIcon = () => (
  <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M6.3685 1.38086H2.9895C1.9595 1.38086 1.125 2.21586 1.125 3.24536V8.66986C1.131 9.71936 1.9865 10.5649 3.036 10.5584C3.056 10.5584 3.0755 10.5579 3.095 10.5574H7.0365C8.0705 10.5469 8.903 9.70436 8.901 8.66986V4.01986L6.3685 1.38086Z" stroke="#D92D20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6.2373 1.375V2.8295C6.2373 3.5395 6.8113 4.115 7.5213 4.117H8.8988" stroke="#D92D20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5.78769 7.32382L4.05469 5.59082" stroke="#D92D20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.05566 7.32382L5.78866 5.59082" stroke="#D92D20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);
export default DeactivateMerchantIcon;
